import { Auth, CognitoHostedUIIdentityProvider } from "@aws-amplify/auth";
import { useState } from "react";
// @ts-ignore - CJS module exposes GoogleButton as a named export at runtime, but types only declare default
import { GoogleButton } from "react-google-button";

export function LoginButton() {
  const [disabled, setDisabled] = useState(false);

  return (
    <div data-testid="signInWithGoogle">
      <GoogleButton
        type="light"
        disabled={disabled}
        onClick={async () => {
          setDisabled(true);
          // Setting provider allows us to self-host the login button
          await Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Google });
        }}
      />
    </div>
  );
}
